import React, { useEffect, useRef, useState } from 'react';

/**
 * ENQUIRY section title with Elementor-style fadeInUp on scroll into view.
 * Replaces WordPress elementor-invisible + Elementor frontend animation in the React app.
 */
function EnquiryHeading({ widgetElementId = 'a868559', title = 'ENQUIRY' }) {
	const ref = useRef(null);
	const [animated, setAnimated] = useState(false);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		if (typeof IntersectionObserver === 'undefined') {
			setAnimated(true);
			return;
		}

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setAnimated(true);
					observer.disconnect();
				}
			},
			{ threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
		);

		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	const visibilityClass = animated ? 'animated fadeInUp' : 'elementor-invisible';

	return (
		<div
			ref={ref}
			className={`elementor-element elementor-element-${widgetElementId} wpr-dual-heading-default elementor-widget elementor-widget-wpr-dual-color-heading tsr-enquiry-heading ${visibilityClass}`}
			data-id={widgetElementId}
			data-element_type="widget"
			data-e-type="widget"
			data-settings='{"_animation":"fadeInUp"}'
			data-widget_type="wpr-dual-color-heading.default"
		>
			<div className="elementor-widget-container">
				<div className="wpr-dual-heading-wrap">
					<div className="wpr-dual-title-wrap">
						<h2 className="wpr-dual-title">
							<span className="first">{title}</span>
						</h2>
					</div>
				</div>
			</div>
		</div>
	);
}

export default EnquiryHeading;
